module.exports = __webpack_public_path__ + "static/media/funnel.ca57128f.svg";